import { useState, useEffect } from 'react'

const TYPE_ICONS = {
  class: '📚',
  meal: '🍽',
  break: '☕',
  task: '✏️',
}

function formatTime12(time24) {
  const [h, m] = time24.split(':').map(Number)
  const ampm = h >= 12 ? 'PM' : 'AM'
  const h12 = h % 12 || 12
  return `${h12}:${m.toString().padStart(2, '0')} ${ampm}`
}

function formatDateLabel(dateStr) {
  const date = new Date(dateStr + 'T00:00:00')
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

function DailySchedules({ loadScheduleByDate, listScheduleDates }) {
  const [dates, setDates] = useState([])
  const [selectedDate, setSelectedDate] = useState(null)
  const [viewSchedule, setViewSchedule] = useState(null)
  const [loading, setLoading] = useState(true)
  const [loadingDetail, setLoadingDetail] = useState(false)

  useEffect(() => {
    listScheduleDates().then((d) => {
      setDates(d)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only fetch, intentionally runs once
  }, [])

  async function handleSelectDate(dateStr) {
    setSelectedDate(dateStr)
    setLoadingDetail(true)
    const sched = await loadScheduleByDate(dateStr)
    setViewSchedule(sched)
    setLoadingDetail(false)
  }

  function handleBack() {
    setSelectedDate(null)
    setViewSchedule(null)
  }

  if (loading) {
    return (
      <div className="page">
        <h2 className="page-title">Daily Plans</h2>
        <div className="loading-indicator">
          <div className="loading-spinner" />
        </div>
      </div>
    )
  }

  // Detail view
  if (selectedDate && viewSchedule) {
    return (
      <div className="page">
        <div className="schedule-readonly-header">
          <button className="btn btn-sm" onClick={handleBack}>
            Back
          </button>
          <h2 className="page-title">{formatDateLabel(selectedDate)}</h2>
        </div>
        <p className="schedule-readonly-times">
          {formatTime12(viewSchedule.dayStart)} – {formatTime12(viewSchedule.dayEnd)}
        </p>
        {viewSchedule.schedule.length > 0 ? (
          <ul className="schedule-list">
            {viewSchedule.schedule.map((item, idx) => (
              <li
                key={`${item.time}-${idx}`}
                className={`schedule-item schedule-item--${item.type}`}
              >
                <span className="schedule-time">
                  {formatTime12(item.time)}
                </span>
                <span className="schedule-icon">{TYPE_ICONS[item.type]}</span>
                {item.type === 'task' ? (
                  <div className="schedule-content">
                    <span className="schedule-title">{item.title}</span>
                    <span className="schedule-end-time">
                      until {formatTime12(item.endTime)}
                    </span>
                  </div>
                ) : (
                  <>
                    <span className="schedule-title">{item.title}</span>
                    <span className="schedule-end-time schedule-end-time--inline">
                      until {formatTime12(item.endTime)}
                    </span>
                  </>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p className="placeholder-text">No schedule items found.</p>
        )}
      </div>
    )
  }

  // Loading detail
  if (selectedDate && loadingDetail) {
    return (
      <div className="page">
        <div className="schedule-readonly-header">
          <button className="btn btn-sm" onClick={handleBack}>
            Back
          </button>
          <h2 className="page-title">{formatDateLabel(selectedDate)}</h2>
        </div>
        <div className="loading-indicator">
          <div className="loading-spinner" />
        </div>
      </div>
    )
  }

  // List view
  return (
    <div className="page">
      <h2 className="page-title">Daily Plans</h2>
      {dates.length === 0 ? (
        <p className="placeholder-text">
          No saved schedules yet. Use "Plan My Day" on the dashboard and save a schedule to see it here.
        </p>
      ) : (
        <ul className="schedule-date-list">
          {dates.map((dateStr) => (
            <li key={dateStr}>
              <button
                className="schedule-date-item"
                onClick={() => handleSelectDate(dateStr)}
              >
                {formatDateLabel(dateStr)}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default DailySchedules
